<template>
  <div class="px-4 sm:px-6 lg:px-8">
    <div class="sm:flex sm:justify-between sm:items-center">
        <select v-model="query.ComponentType" name="country" autocomplete="country-name" class="sm:hidden mt-3 mr-4 w-48 inline-block bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
          <option :value="4" :selected="query.ComponentType === 4">应用规则</option>
          <option :value="0" :selected="query.ComponentType === 0">功能组件</option>
          <option :value="1" :selected="query.ComponentType === 1">子流程</option>
          <option :value="3" :selected="query.ComponentType === 3">大组件</option>
          <option :value="8" :selected="query.ComponentType === 8">流程模板</option>
        </select>
        <nav class="space-x-4 hidden sm:block pb-4 mt-3" aria-label="Tabs">
        <a href="#" @click="query.ComponentType = 4" :class="[query.ComponentType === 4 ? 'bg-indigo-100 text-indigo-700' : 'text-gray-500 hover:text-gray-700']" class="px-3 py-1 font-medium text-sm rounded-md">应用规则</a>
        <a href="#" @click="query.ComponentType = 0" :class="[query.ComponentType === 0 ? 'bg-indigo-100 text-indigo-700' : 'text-gray-500 hover:text-gray-700']" class="px-3 py-1 font-medium text-sm rounded-md">功能组件</a>
        <a href="#" @click="query.ComponentType = 1" :class="[query.ComponentType === 1 ? 'bg-indigo-100 text-indigo-700' : 'text-gray-500 hover:text-gray-700']" class="px-3 py-1 font-medium text-sm rounded-md">子流程</a>
        <a href="#" @click="query.ComponentType = 3" :class="[query.ComponentType === 3 ? 'bg-indigo-100 text-indigo-700' : 'text-gray-500 hover:text-gray-700']" class="px-3 py-1 font-medium text-sm rounded-md">大组件</a>
        <a href="#" @click="query.ComponentType = 8" :class="[query.ComponentType === 8 ? 'bg-indigo-100 text-indigo-700' : 'text-gray-500 hover:text-gray-700']" class="px-3 py-1 font-medium text-sm rounded-md">流程模板</a>
        </nav>
        <input v-model="query.Keyword" type="text" name="first-name" placeholder="关键字筛选" autocomplete="given-name" class=" -mt-2 mr-4 inline-block border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
    </div>
    <div class="mt-4 flex flex-col">
      <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
          <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
            <table class="min-w-full divide-y divide-gray-300">
              <thead class="bg-gray-50">
                <tr>
                  <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">ID</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">名称</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">应用类型</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">版本</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">创建时间</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">提取码</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">有效期</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">是否有效</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">下载次数</th>
                  <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-6">
                    <span class="sr-only">操作</span>
                  </th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-200 bg-white">
                <tr v-for="item in tableData" :key="item.id">
                  <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">{{item.Id}}</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500"><a :href="`${protocol}//dev.www.huoyuyan.com/share.html?key=${item.ShareKey}`" class="text-indigo-600" target="_blank">{{item.Name}}</a></td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{componentTypes[item.ComponentType]}}</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{item.Version}}</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{item.AddTime}}</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{item.Code}}</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                    <template v-if="item.ExpirationTime === 0">永久</template>
                    <template v-else>{{item.ExpirationTime}}天</template>
                  </td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                    <span v-if="item.IsValid" class="text-green-600">是</span>
                    <span class="text-red-500" v-else>否</span>
                  </td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{item.DownloadCount}}</td>
                  <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                    <a href="javascript:;" class="text-gray-500 hover:text-gray-900 inline-block mr-1" @click="view(item)" title="查看">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 12h16.5m-16.5 3.75h16.5M3.75 19.5h16.5M5.625 4.5h12.75a1.875 1.875 0 010 3.75H5.625a1.875 1.875 0 010-3.75z" />
                      </svg>
                    </a>
                    <a href="javascript:;" class="text-gray-500 hover:text-gray-900 inline-block mr-1" @click="copy(item)" title="复制">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-4 w-4 text-gray-500">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                      </svg>
                    </a>
                    <a href="javascript:;" class="text-gray-500 hover:text-gray-900 inline-block mr-1" @click="remove(item)" title="删除">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                      </svg>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <Pagination :size="query.PageSize" :page="query.PageIndex" :total="total" @change="changePage" />
    <Alert :visible.sync="alertShow" ref="alert" />
    <Notify ref="notify" />
    <Modal :visible.sync="versionDialog" title="分享详情内容" :ActionBtnShow="false" width="max-w-3xl">
      <div class="space-y-6 sm:space-y-0 my-4 mx-2 px-4 py-0">
        <div>
        <h2 class="text-base font-extrabold text-gray-900 mt-6">{{detail.Name}}</h2>
      </div>
      <div class="mt-4 block">
        <div class="text-gray-900 my-4 block box-border text-sm">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 inline-block align-sub">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          {{detail.AddTime}}
          <span class="text-gray-500 ml-4">有效期：</span>
          <template v-if="!detail.IsValid">已过期</template>
          <template v-else>
            <template v-if="detail.ExpirationTime === 0">永久</template>
            <template v-else>{{detail.ExpirationTime}}天</template>
          </template>
        </div>
        <div class="relative block box-border text-sm">
          <a :href="$store.state.apiServer+'web/share/download?k='+detail.ShareKey" target="_blank" class="cursor-pointer inline-block text-white bg-indigo-600 hover:bg-indigo-700 py-2 px-3 border border-gray-300 rounded-md shadow-sm text-sm leading-4 font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 absolute right-0">下载文件</a>
          <template v-if="detail.Info && detail.Info !== ''">
            <div class="text-gray-900 my-2"><span class="text-gray-500">应用类型：</span>{{componentTypes[detail.ComponentType]}}</div>
            <div class="text-gray-900 my-2"><span class="text-gray-500">流程数：</span>{{detail.Info.flow_count}}</div>
            <div class="text-gray-900 my-2"><span class="text-gray-500">窗体数：</span>{{detail.Info.form_count}}</div>
            <div class="text-gray-900 my-2"><span class="text-gray-500">变量数：</span>{{detail.Info.var_count}}</div>
            <div class="text-gray-900 my-2"><span class="text-gray-500">控件数：</span>{{detail.Info.layer_count}}</div>
            <div class="text-gray-900 my-2"><span class="text-gray-500">颗粒组件数：</span>{{detail.Info.component_count}}</div>
            <div class="text-gray-900 my-2"><span class="text-gray-500">逻辑组件数：</span>{{detail.Info.logic_count}}</div>
            <div class="text-gray-900 my-2"><span class="text-gray-500">复合组件数：</span>{{detail.Info.complex_count}}</div>
            <div class="text-gray-900 my-4"><span class="text-gray-500">备注：</span>{{detail.Remark || '--'}}</div>
          </template>
        </div>
      </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import Pagination from '../components/Pagination.vue'
import Alert from '../components/Alert.vue'
import Notify from '../components/Notification.vue'
import { pageList, removeShare, getDetail } from '../api/Share'
import { debounce } from 'lodash'
import Modal from '../components/Modal.vue'
export default {
  name: 'ShareList',
  components: { Alert, Notify, Pagination, Modal },
  data () {
    return {
      alertShow: false,
      modalShow: false,
      versionDialog: false,
      query: {
        PageIndex: 1,
        PageSize: 10,
        Keyword: '',
        ComponentType: 4,
        OrderBy: '-Id'
      },
      key: '',
      versions: [],
      tableData: [],
      total: 0,
      detail: { Name: '' },
      protocol: window.location.protocol,
      componentTypes: {
        0: '功能组件',
        4: '控制台应用',
        1: '子流程',
        3: '大组件',
        6: '逻辑组件',
        8: '流程模板',
        11: '界面应用'
      }
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    copy (item) {
      const text = `${window.location.protocol}//dev.www.huoyuyan.com/share.html?key=${item.ShareKey}`
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            this.notifyShow({ title: '链接已复制到剪切板', desc: '' })
          })
          .catch((err) => {
            console.error('无法复制此文本：', err)
          })
      } else {
        // 创建text area
        const textArea = document.createElement('textarea')
        textArea.value = text
        document.body.appendChild(textArea)
        textArea.style.position = 'absolute'
        textArea.style.opacity = 0
        textArea.style.left = '-999999px'
        textArea.style.top = '-999999px'
        textArea.focus()
        textArea.select()
        return new Promise((resolve, reject) => {
          // 执行复制命令并移除文本框
          document.execCommand('copy') ? resolve() : reject(new Error('出错了'))
          textArea.remove()
        }).then(
          () => {
            this.notifyShow({ title: '链接已复制到剪切板', desc: '' })
          },
          (err) => {
            console.error('无法复制此文本：', err)
          }
        )
      }
    },
    view (row) {
      getDetail(row.Key).then(res => {
        this.detail = res.data.data
        if (this.detail.Info !== '') {
          this.detail.Info = JSON.parse(this.detail.Info)
        }
        this.versionDialog = true
      }).catch((err) => {
        console.log(err)
      })
    },
    changePage (page) {
      this.query.PageIndex = page
    },
    notifyShow (msg = { title: '', desc: '', timeout: 3000 }) {
      this.$refs.notify.show(msg)
    },
    refreshData: debounce(
      function () {
        this.getList()
      },
      800
    ),
    remove (item) {
      this.alertShow = true
      new Promise((resolve, reject) => {
        const instance = this.$refs.alert
        instance.confirm = () => {
          this.alertShow = false
          resolve()
        }
        instance.cancel = () => {
          this.alertShow = false
          reject()
        }
      }).then(() => {
        removeShare(item.Key).then(() => {
          this.notifyShow({ title: '删除成功' })
          this.getList()
        })
      }).catch(() => { console.log('cancel') })
    },
    getList () {
      this.loading = true
      pageList(this.queryString).then(res => {
        const data = res.data.data
        if (!data.list) data.list = []
        this.tableData = data.list
        this.query.PageIndex = data.page
        this.total = data.total
        // this.$refs.multipleTable.doLayout()
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    }
  },
  watch: {
    query: {
      handler: function () {
        this.refreshData()
      },
      deep: true
    }
  },
  computed: {
    queryString: function () {
      return Object.keys(this.query).filter(key => this.query[key] !== '')
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(this.query[key]))
        .join('&')
    }
  }
}
</script>
